import type { ReactElement, VoidFunctionComponent } from 'react';

import Card from '../../../generic/Card/Card';
import { InventoryViewHeader } from '../InventoryViewHeader/InventoryViewHeader';

import { ProjectBinaryTree, ReleaseGroupBinaryTree } from './BinaryTree';

type Props = {
  scope: 'project' | 'releaseGroup';
};

/**
 * BinaryAnalysisContainer is a component that displays a file tree of the binary analysis.
 * It is used to display the file tree of the binary analysis.
 * It is also used to display the file tree of the binary analysis.
 */
const BinaryAnalysisContainer: VoidFunctionComponent<Props> = ({ scope }) => {
  let treeComponent: ReactElement;
  if (scope === 'project') {
    treeComponent = <ProjectBinaryTree />;
  } else {
    treeComponent = <ReleaseGroupBinaryTree />;
  }

  return (
    <>
      <InventoryViewHeader title="Binary Analysis" />
      <Card isFullWidth>
        <Card.Header>File Tree</Card.Header>
        <Card.Content>
          {treeComponent}
        </Card.Content>
      </Card>
    </>
  );
};

export default BinaryAnalysisContainer;
